import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/Common.module.css';
import Button from '../Styles/Button.module.css';
import BreadcrumbComponent from "../Common/CommonSections/Breadcrum";
import { BiPhoneCall } from "react-icons/bi";
import { GoMail } from "react-icons/go";
import { Link } from "react-router-dom";
import { getCountryListFormData, getCountrydirectCityListFormData } from '../../services/routes.services';
import constants from '../../services/constants'

const ContactUSPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        country: '',
        city: '',
        query: ''
    });

    const [countryList, setCountryList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [response, setResponse] = useState(null);

    useEffect(() => {
        getCountryListFormData()
            .then((res) => {
                const CountryList = res.data.countries;
                setCountryList(CountryList);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleCountryChange = (e) => {
        // const selectedOption = e.target.options[e.target.selectedIndex];
        // const countryCode = selectedOption.getAttribute('data-code'); // Custom data attribute

     
        const selectedCountry = e.target.value;
        setFormData({
            ...formData,
            country: selectedCountry,
            city: '' // Reset city when country changes
        });
        setCityList([]);
        if (selectedCountry) {
            getCountrydirectCityListFormData(selectedCountry)
                .then((res) => {
                    const CityList = res.data;
                    setCityList(CityList);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(constants.API_BASE_URL+'/enquiry/post', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            const data = await res.json();
            setResponse(data);
            setFormData({
                name: '',
                email: '',
                phone: '',
                country: '',
                city: '',
                query: ''
            });
        } catch (error) {
            console.error('Error:', error);
        }
    };
    const resetButtonHandler = () => {
    setFormData({
        name: '',
        email: '',
        phone: '',
        country: '',
        city: '',
        query: ''
    });
    setCityList([]);
    setResponse(null); // Optional
};

    return (
        <div>
            <BreadcrumbComponent home='Home' listOne="Contact Us" />
            <div className={Style.pageTitle + ' ' + Style.componentsSpace}>
                <Container>
                    <Row>
                        <Col>
                            <div className={Style.sectionTitle}>
                                <h2>Contact Us</h2>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <div className={Style.contactPage}>
                    <Container>
                        <Row>
                            <Col md={7}>
                                <div className={Style.formContainer}>
                                    <form onSubmit={handleSubmit}>
                                        <div className={Style.fromElement}>
                                            <div className={Style.elementBox}>
                                                <label>Full Name <sup>*</sup></label>
                                                <input type='text' name='name' value={formData.name} onChange={handleInputChange} required/>
                                            </div>
                                            <div className={Style.elementBox}>
                                                <label>Email Id <sup>*</sup></label>
                                                <input type='email' name='email' value={formData.email} onChange={handleInputChange} required/>
                                            </div>
                                        </div>
                                        <div className={Style.fromElement}>
                                            <div className={Style.elementBox}>
                                                <label>Mobile No <sup>*</sup></label>
                                                <input type='text' name='phone' value={formData.phone} onChange={handleInputChange} required/>
                                            </div>
                                            <div className={Style.elementBox}>
                                                <label>Country <sup>*</sup></label>
                                                <select name='country' value={formData.country} onChange={handleCountryChange} required>
                                                    <option value=''>Select Country</option>
                                                    {countryList && countryList.map(country => (
                                                        <option key={country.id} value={country.id} data-code={country._id}>{country.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className={Style.fromElement}>
                                            <div className={Style.elementBox}>
                                                <label>City <sup>*</sup></label>
                                                <select name='city' value={formData.city} onChange={handleInputChange} required>
                                                    <option value=''>Select City</option>
                                                    {cityList && cityList.map(city => (
                                                        <option key={city.iso2} value={city.iso2}>{city.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className={Style.fromElement}>
                                            <div className={Style.elementBox}>
                                                <label>Message <sup>*</sup></label>
                                                <textarea type='text' name='query' value={formData.query} onChange={handleInputChange} required></textarea>
                                            </div>
                                        </div>
                                        <div className={Style.fromElement}>
                                            <div className={Style.fomBtn}>
                                                <button type="submit" className={Button.greenBtn + ' ' + Button.greenBtnLg}>Submit</button>
                                                <button type="button" className={Style.CancelBtn} onClick={resetButtonHandler}>Cancel</button>
                                            </div>
                                        </div>
                                        {response && (
                                            <div className={Style.responseMsg}>
                                                <h2>Thank you! We'll get in touch with you soon.</h2>
                                            </div>
                                        )}
                                    </form>
                                </div>
                            </Col>
                            <Col md={5}>
                                <div className={Style.mayoInfo}>
                                    <h4>Mayo College Alumni Association, Delhi</h4>
                                    <p><strong>Registered Address -</strong> C 39, Niti Bagh, New Delhi - 110049</p>
                                    <p><strong>Correspondence Address -</strong> 508, 5th Floor, Akashdeep Building, Barakhamba Road, New Delhi - 110001, India</p>
                                    <p><BiPhoneCall /> <Link to="tel:+91 - 11 - 23351880">+91 - 11 - 23351880</Link></p>
                                    <p><GoMail /> <Link to='mailto:Secretary@Mayoalumni.In'>Secretary@Mayoalumni.In</Link></p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </div>
    );
}

export default ContactUSPage;
